import { ROUTES } from "@/shared/constants/routes";
import RocketIcon from "@/shared/icons/rocket";
import SessionsIcon from "@/shared/icons/sessions";
import SettingsIcon from "@/shared/icons/settings";
import TeamIcon from "@/shared/icons/team";
import { Sparkles, Building2, HelpCircle, FileBadge, ShieldCheck } from "lucide-react";
import { NavItemData } from "../types/sidebar";

// Main navigation items (top section)
export const mainSidebarItems: NavItemData[] = [
  // {
  //   title: "AI Agent",
  //   Icon: RocketIcon,
  //   path: ROUTES.AGENT,
  // },
  // {
  //   title: "Sessions",
  //   Icon: SessionsIcon,
  //   path: ROUTES.AGENT_SESSIONS,
  // },
  {
    title: "Compliance",
    Icon: FileBadge,
    path: ROUTES.COMPLIANCE_GAP_ASSESSMENTS,
    canAccess: (permissions) => permissions.canAccessZaniaGapAssessment,
    children: [
      { title: "Gap Assessments", path: ROUTES.COMPLIANCE_GAP_ASSESSMENTS },
    ],
  },
  {
    title: "Third-Party Risk",
    Icon: Building2,
    path: ROUTES.THIRD_PARTY_HOME,
    canAccess: (permissions) => permissions.canAccessZaniaVendorAssessment,
    children: [
      { title: "Home", path: ROUTES.THIRD_PARTY_HOME },
      { title: "All Third-Parties", path: ROUTES.THIRD_PARTY_VENDORS },
      { title: "Breach History", path: ROUTES.THIRD_PARTY_BREACH_HISTORY },
      { title: "Issues", path: ROUTES.THIRD_PARTY_ISSUES },
      { title: "Sessions", path: ROUTES.THIRD_PARTY_SESSIONS },
    ],
  },
  {
    title: "Internal Risk",
    Icon: ShieldCheck,
    path: ROUTES.INTERNAL_RISK_ASSESSMENTS,
    canAccess: (permissions) => permissions.canAccessZaniaRiskAssessment,
    children: [
      { title: "Risk Assessments", path: ROUTES.INTERNAL_RISK_ASSESSMENTS },
    ],
  },
  {
    title: "Ask Zania",
    Icon: Sparkles,
    path: ROUTES.ASK_AI,
    canAccess: (permissions) => permissions.canAccessZaniaAskAi,
    featureName: "askZania",
  },
];

// Bottom navigation items (above user profile)
export const bottomSidebarItems: NavItemData[] = [
  {
    title: "Help",
    Icon: HelpCircle,
    path: "#",
    isPlaceholder: true,
  },
  {
    title: "Team",
    Icon: TeamIcon,
    path: ROUTES.TEAM,
  },
  {
    title: "Settings",
    Icon: SettingsIcon,
    path: ROUTES.SETTINGS,
  },
];

// Legacy export for backward compatibility
export const sidebarItems: NavItemData[] = [
  ...mainSidebarItems,
  ...bottomSidebarItems,
];
